export type MovementRawRow = {
  date: string
  transactionType: string
  reference: string
  location: string
  stockIn: number
  stockOut: number
  actualClosing: number
  cost: number
  createdBy: string
  note: string
}

export type MovementControlStatus = "OK" | "WARNING" | "ERROR"

export type MovementControlRow = {
  date: string
  transactionType: string
  reference: string
  location: string
  opening: number
  stockIn: number
  stockOut: number
  expectedClosing: number
  actualClosing: number
  variance: number
  cost: number
  value: number
  status: MovementControlStatus
  controlNote: string
  createdBy: string
  note: string
}

export type MovementFilter = {
  dateFrom: string
  dateTo: string
  location: string
  controlStatus: "All" | MovementControlStatus
  transactionType: string
  search: string
}

export type MovementSortKey =
  | "date"
  | "transactionType"
  | "reference"
  | "location"
  | "opening"
  | "stockIn"
  | "stockOut"
  | "expectedClosing"
  | "actualClosing"
  | "variance"
  | "cost"
  | "value"
  | "status"

export type MovementSortState = {
  key: MovementSortKey
  asc: boolean
}

export type MovementExportOutputType = "xls" | "pdf" | "print"

export const LOCATION_OPTIONS = [
  { value: "All Locations", label: "All Locations" },
  { value: "Main Warehouse", label: "Main Warehouse" },
  { value: "Retail Store", label: "Retail Store" },
  { value: "Project Site", label: "Project Site" },
  { value: "Resort Store", label: "Resort Store" },
  { value: "Production", label: "Production" }
] as const

export const CONTROL_STATUS_OPTIONS = [
  { value: "All", label: "All" },
  { value: "OK", label: "OK" },
  { value: "WARNING", label: "WARNING" },
  { value: "ERROR", label: "ERROR" }
] as const

export const TRANSACTION_TYPE_OPTIONS = [
  { value: "All", label: "All" },
  { value: "Opening Balance", label: "Opening Balance" },
  { value: "Purchase Receive", label: "Purchase Receive" },
  { value: "Sales Issue", label: "Sales Issue" },
  { value: "Stock Adjustment", label: "Stock Adjustment" },
  { value: "Stock Transfer", label: "Stock Transfer" },
  { value: "Build Item", label: "Build Item" },
  { value: "Goods Request", label: "Goods Request" },
  { value: "Stock Count", label: "Stock Count" }
] as const

export const DEFAULT_MOVEMENT_FILTER: MovementFilter = {
  dateFrom: "2026-05-01",
  dateTo: "2026-05-31",
  location: "All Locations",
  controlStatus: "All",
  transactionType: "All",
  search: ""
}
